import type { IPreviewOrigin } from '@srm/ui/file-preview';
import { httpPreviewSource } from '@srm/ui/file-preview/source';
import $api from '@/http';
import { FilesService } from './FilesService';

/** Окно предпросмотра Front: запросы — общим клиентом (Bearer, обновление токена на 401), скачивание — с тостом отказа. */
export const filePreviewSource = httpPreviewSource({
    client: $api,
    download: (url, options) => FilesService.downloadFile(url, undefined, options),
});

const path = (...parts: string[]): string => parts.map(encodeURIComponent).join('/');

/** Вложение документа: права — та же цепочка доступа, что у скачивания. */
export const attachmentPreview = (documentKey: string, attachKey: string): IPreviewOrigin => ({
    path: `attachment/view/${path(documentKey, attachKey)}`,
    download: `attachment/download/${path(documentKey, attachKey)}`,
});

/** Файл раздела «Документация» с диска (`Documentation.xml`). */
export const documentationFilePreview = (catalogKey: number, fileName: string): IPreviewOrigin => ({
    path: 'documentation/view',
    params: { catalogKey, fileName },
    download: `documentation/download?${new URLSearchParams({ catalogKey: String(catalogKey), fileName })}`,
});

/** Документ из БД по постоянному адресу; `version` — sha256 версии: адреса неизменяемы, браузер кэширует их. */
export const documentationItemPreview = (slug: string, version: string): IPreviewOrigin => ({
    path: `documentation/items/${path(slug)}/view`,
    params: { v: version },
    download: `documentation/items/${path(slug)}/content?${new URLSearchParams({ v: version, download: 'true' })}`,
});
